import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

import Apple from "./assets/icon-apple-t5.svg";
import Facebook from "./assets/icon-facebook-t5.svg";
import Google from "./assets/icon-google-t5.svg";
import Office365 from "./assets/icon-office365-t5.svg";
import Outlook from "./assets/icon-outlook-t5.svg";
import OutlookCom from "./assets/icon-outlookcom-t5.svg";
import Yahoo from "./assets/icon-yahoo-t5.svg";

export const AddToCalendarWrapper = withViewportStyle("div")`
  position: relative;
  width: min-content;

  ${(props) =>
    props.$viewport.mobile`
      width: 100%;
    `}

  .addeventatc:active {
    outline: 0 !important;
  }
  .addeventatc .start,
  .addeventatc .end,
  .addeventatc .timezone,
  .addeventatc .title,
  .addeventatc .description,
  .addeventatc .location,
  .addeventatc .organizer,
  .addeventatc .organizer_email,
  .addeventatc .facebook_event,
  .addeventatc .all_day_event,
  .addeventatc .date_format,
  .addeventatc .alarm_reminder,
  .addeventatc .recurring,
  .addeventatc .attendees,
  .addeventatc .calname,
  .addeventatc .uid,
  .addeventatc .status,
  .addeventatc .method,
  .addeventatc .client,
  .addeventatc .transp {
    display: none !important;
  }

  /* Drop down */
  .addeventatc_dropdown {
    width: 14.375rem;
    position: absolute;
    padding: 0.375rem 0 0 0;
    color: #000 !important;
    font-weight: 600;
    line-height: 100%;
    background: #fff;
    font-size: 0.9375rem;
    text-decoration: none;
    text-align: left;
    margin-left: -0.0625rem;
    display: none;
    -moz-border-radius: 0.1875rem;
    -webkit-border-radius: 0.1875rem;
    border-radius: 0.1875rem;
    -webkit-box-shadow: rgba(0, 0, 0, 0.4) 0 0.625rem 1.625rem;
    -moz-box-shadow: rgba(0, 0, 0, 0.4) 0 0.625rem 1.625rem;
    box-shadow: rgba(0, 0, 0, 0.4) 0 0.625rem 1.625rem;
    transform: scale(0.98, 0.98) translateY(0.3125rem);
    transition: transform 0.15s ease;
    -webkit-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  .addeventatc_dropdown.topdown {
    transform: scale(0.98, 0.98) translateY(-0.3125rem) !important;
  }
  .addeventatc_dropdown span {
    display: block;
    line-height: 100%;
    background: #fff;
    text-decoration: none;
    cursor: pointer;
    font-size: 0.9375rem;
    color: #333;
    font-weight: 600;
    padding: 0.875rem 0.625rem 0.875rem 3.4375rem;
    margin: -0.125rem 0;
  }
  .addeventatc_dropdown span:hover {
    background-color: #f4f4f4;
    color: #000;
    text-decoration: none;
    font-size: 0.9375rem;
  }
  .addeventatc_dropdown span[role="button"]:focus-visible,
  .addeventatc_dropdown .frs a:focus-visible {
    outline: 2px solid #1a73e8;
    outline-offset: 2px;
  }
  .addeventatc_dropdown .online {
    display: inline;
    padding: 0;
    background: transparent;
    color: #999 !important;
    font-size: 0.75rem !important;
    font-weight: 400;
  }
  .addeventatc_dropdown .frs a {
    background: #fff;
    color: #cacaca !important;
    cursor: pointer;
    font-size: 0.5625rem !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 110% !important;
    padding-left: 0.625rem;
    position: absolute;
    right: 0.625rem;
    text-align: right;
    text-decoration: none;
    top: 0.3125rem;
    border-bottom: 0;
  }
  .addeventatc_dropdown .frs a:hover {
    color: #999 !important;
  }
  .addeventatc_dropdown .ateappleical {
    background: url(${Apple.src}) 1.125rem 40% no-repeat;
    background-size: 1.375rem 100%;
  }
  .addeventatc_dropdown .ategoogle {
    background: url(${Google.src}) 1.125rem 50% no-repeat;
    background-size: 1.375rem 100%;
  }
  .addeventatc_dropdown .ateoffice365 {
    background: url(${Office365.src}) 1.1875rem 50% no-repeat;
    background-size: 1.125rem 100%;
  }
  .addeventatc_dropdown .ateoutlook {
    background: url(${Outlook.src}) 1.125rem 50% no-repeat;
    background-size: 1.375rem 100%;
  }
  .addeventatc_dropdown .ateoutlookcom {
    background: url(${OutlookCom.src}) 1.125rem 50% no-repeat;
    background-size: 1.375rem 100%;
  }
  .addeventatc_dropdown .ateyahoo {
    background: url(${Yahoo.src}) 1.125rem 50% no-repeat;
    background-size: 1.375rem 100%;
  }
  .addeventatc_dropdown .atefacebook {
    background: url(${Facebook.src}) 1.125rem 50% no-repeat;
    background-size: 1.375rem 100%;
  }
  .addeventatc_dropdown .copyx {
    height: 1.3125rem;
    display: block;
    position: relative;
    cursor: default;
  }
  .addeventatc_dropdown .brx {
    height: 0.0625rem;
    overflow: hidden;
    background: #e8e8e8;
    position: absolute;
    left: 0.625rem;
    right: 0.625rem;
    top: 0.5625rem;
  }
  .addeventatc_dropdown.addeventatc-selected {
    transform: scale(1, 1) translateY(0);
    z-index: var(--z-index-lowest);
  }
  .addeventatc_dropdown.topdown.addeventatc-selected {
    transform: scale(1, 1) translateY(0) !important;
  }
  .addeventatc_dropdown .drop_markup {
    background-color: #f4f4f4;
  }
`;
